import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_PRODUCTION_URL} from '../../connection.data';
import { Machine, Shift, ShiftActions } from '../../plant-configuration';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
//const API_USERS_URL = 'api/users';
//const API_PERMISSION_URL = 'api/permissions';
//const API_ROLES_URL = 'api/roles';

//const BASE_URL = "http://localhost:3000"                //INTERNAL DEV
//const BASE_URL = "http://ir4hub.cl:45016"                //LAB DEV

@Injectable()
export class ProductionService{
    public dataPesometerRowToEdit:any
    constructor(private http: HttpClient){

    }

    getInstantVelocity(machine:Machine):Observable<number>{
        const url = `${API_PRODUCTION_URL}/velocity/instant/${machine.id}`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                try{
                    return response.rows[0].velocity;
                }catch(error){
                    console.log(error.message);
                    return 0;
                }
            })
        )
    }

    getAllInstantVelocity():Observable<any[]>{
        const url = `${API_PRODUCTION_URL}/velocity/instant/all`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getShiftStatsPerMachine(shift: Shift):Observable<any[]>{
        const url = `${API_PRODUCTION_URL}/summary/shift?shift=${shift.id}`;
        console.log(url)
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getShiftStatsPerMachineInPeriod(shift: Shift, st, et):Observable<any[]>{
        const url = `${API_PRODUCTION_URL}/summary/shift/period?shift=${shift.id}&st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        console.log(url)
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getStatsPerPeriod(machine:Machine, shift:Shift, st: Date, et: Date):Observable<any>{
        var url = `${API_PRODUCTION_URL}/summary/period?machine=${machine.id}&st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        if(shift){
            url+=`&shift=${shift.id}`
        }
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getShiftVelocity(machine:Machine, shift:Shift):Observable<number>{
        const url = `${API_PRODUCTION_URL}/velocity/shift?machine=${machine.id}&shift=${shift.id}`;
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return parseFloat(response.velocity);
            })
        )
    }

    plantShiftHistory(shift, st = null, et = null):Observable<any>{
        var url = `${API_PRODUCTION_URL}/units/history/plant/shift?shift=${shift.id}`;
        if(st!=null){
            url += `&st=${encodeURIComponent(formatDate(st))}`;
        }
        if(et!=null){
            url += `&et=${encodeURIComponent(formatDate(et))}`;
        }
        return this.http.get<any>(url);
    }

    plantPeriodHistory(st, et ):Observable<any>{
        var url = `${API_PRODUCTION_URL}/units/history/plant?st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        return this.http.get<any>(url);
    }

    plantCurrentShiftHistory():Observable<any>{
        const url = `${API_PRODUCTION_URL}/units/history/plant/shift/current`;
        console.log(url);
        return this.http.get<any>(url);
    }

    getShiftTotalUnits(machine:Machine, shift:Shift):Observable<number>{
        const url = `${API_PRODUCTION_URL}/units/shift?machine=${machine.id}&shift=${shift.id}`;
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return parseInt(response.units);
            })
        )
    }

    getYearTotalUnits(machine:Machine):Observable<number>{
        const url = `${API_PRODUCTION_URL}/units/year?machine=${machine.id}`;
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return parseInt(response.units);
            })
        )
    }

    getShiftHistoryPerMinute(machine:Machine, shift:Shift, st = null, et = null):Observable<any[]>{

        var url = `${API_PRODUCTION_URL}/units/history/shift?machine=${machine.id}&shift=${shift.id}`;
        if(st!=null){
            url += `&st=${encodeURIComponent(formatDate(st))}`;
        }
        if(et!=null){
            url += `&et=${encodeURIComponent(formatDate(et))}`;
        }
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getCurrentShiftHistoryPerMinute(machine:Machine):Observable<any[]>{
        const url = `${API_PRODUCTION_URL}/units/history/shift/current?machine=${machine.id}`;
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getStatsPerDay(machine:Machine, st, et):Observable<any[]>{
        const stStr = encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'));
        const etStr = encodeURIComponent(et.toLocaleString('sv').replace(' ', 'T'));
        var url = `${API_PRODUCTION_URL}/stats/history/days?st=${stStr}&et=${etStr}`;
        if(machine){
            url += `&machine=${machine.id}`;
        }
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getStatsPerDayByProductType(productTypeId, shift, st, et):Observable<any[]>{
        const stStr = encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'));
        const etStr = encodeURIComponent(et.toLocaleString('sv').replace(' ', 'T'));
        var url = `${API_PRODUCTION_URL}/stats/history/days/product-type?st=${stStr}&et=${etStr}`;
        if(productTypeId){
            url += `&product_type=${productTypeId}`;
        }
        if(shift){
            url += `&shift=${shift.id}`;
        }
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getStatsPerDayByProduct(productId, shift, st, et):Observable<any[]>{
        const stStr = encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'));
        const etStr = encodeURIComponent(et.toLocaleString('sv').replace(' ', 'T'));
        var url = `${API_PRODUCTION_URL}/stats/history/days/product?st=${stStr}&et=${etStr}`;
        if(productId){
            url += `&product=${productId}`;
        }
        if(shift){
            url += `&shift=${shift.id}`;
        }
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

	getShiftStatsNew(shift, machine, productTypeId, st, et):Observable<any>{
        const stStr = encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'));
        const etStr = encodeURIComponent(et.toLocaleString('sv').replace(' ', 'T'));
        var url = `${API_PRODUCTION_URL}/stats/history/days/shift2?st=${stStr}&et=${etStr}`;
        if(productTypeId){
            url += `&product_type=${productTypeId}`;
        }
        if(shift){
            url += `&shift=${shift.id}`;
        }
        if(machine){
            url += `&machine=${machine.id}`;
        }
        // `machine` es opcional: el reporte de fin de turno consulta el
        // histórico completo cuando la API nueva devuelve una lista vacía.
        if(machine){
            console.log(`stest machine: ${machine.id} - ${machine.name}`)
        }else{
            console.log('stest machine: todas')
        }
        console.log(`stest get shiftstats: ${url}`);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                console.log(`stest get shiftstats response: `, response);
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }
    getShiftStats(shift, machine, productTypeId, st, et):Observable<any>{
        const stStr = encodeURIComponent(st.toLocaleString('sv').replace(' ', 'T'));
        const etStr = encodeURIComponent(et.toLocaleString('sv').replace(' ', 'T'));
        var url = `${API_PRODUCTION_URL}/stats/history/days/shift?st=${stStr}&et=${etStr}`;
        if(productTypeId){
            url += `&product_type=${productTypeId}`;
        }
        if(shift){
            url += `&shift=${shift.id}`;
        }
        if(machine){
            url += `&machine=${machine.id}`;
        }
        console.log(`stest machine: ${machine.id} - ${machine.name}`)
        console.log(`stest get shiftstats: ${url}`);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                console.log(`stest get shiftstats response: `, response);
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    // getPage(queryParams: QueryParamsModel):Observable<QueryResultsModel>{
    //     const url = `${API_PRODUCTION_URL}/page`;
    //     return this.http.post<QueryResultsModel>(url, queryParams)
    // }

    // add(machine:Machine):Observable<number>{
    //     return this.http.post<any>(API_PRODUCTION_URL, machine).pipe(
    //         map((response)=> response.id)
    //     );
    // }

    // edit(machine:Machine):Observable<string>{
    //     return this.http.put<any>(`${API_PRODUCTION_URL}/${machine.id}`, machine).pipe(
    //         map((response)=>response.status)
    //     );
    // }

    // delete(machine:Machine):Observable<string>{
    //     return this.http.delete<any>(`${API_PRODUCTION_URL}/${machine.id}`).pipe(
    //         map((response)=>response.status)
    //     );
    // }

    sendPesometerDataRow(row:any): any{
        this.dataPesometerRowToEdit = row ;
        console.log('Data enviada a editar: ', this.dataPesometerRowToEdit);
    }

    getDryingHistoryPerMinute(st:Date, et:Date, shiftId:number = null): Observable<any[]>{
        var url = `${API_PRODUCTION_URL}/units/history/drying?st=${st}&et=${et}`;
        if(shiftId)
            url += `&shift=${shiftId}`;
        return this.http.get<any>(url).pipe(
            map((response)=>{
                if(response.status=='error'){return []}
                return response.rows
            })
        )
    }

    getMachineTemperature(machine:Machine): Observable<any[]>{
        var url = `${API_PRODUCTION_URL}/machine/temperature/${machine.id}`;
        // console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }

    getMachineStatus(machine:Machine): Observable<any>{
        var url = `${API_PRODUCTION_URL}/machine/status/${machine.id}`;
        // console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }

    getLastSileUploadingId(): Observable<number>{
        var url = `${API_PRODUCTION_URL}/sile/uploading/last`;
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }

    getSileLastVariety(machine:Machine): Observable<any>{
        var url = `${API_PRODUCTION_URL}/sile/variety/last/${machine.id}`;
        // console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }

    getSileTemperaturePeriod(machine:Machine, st:Date, et:Date): Observable<any>{
        var url = `${API_PRODUCTION_URL}/sile/temperature/period/${machine.id}?st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }

    getDryingHistoryPerDay(st:Date, et:Date, shift:Shift=null): Observable<any>{
        var url = `${API_PRODUCTION_URL}/stats/drying/history/days?st=${encodeURIComponent(formatDate(st))}&et=${encodeURIComponent(formatDate(et))}`;
        if(shift){
            url += `&shift_id=${shift.id}`
        }
        console.log(url);
        return this.http.get<any>(url).pipe(
            map((response)=>{
                return response.rows
            })
        )
    }
}

function formatDate(date:Date){
    const year = date.getFullYear();
    const month = numberTo2DigitsString(date.getMonth() +1);
    const day = numberTo2DigitsString(date.getDate());
    const hours = numberTo2DigitsString(date.getHours());
    const minutes = numberTo2DigitsString(date.getMinutes());
    const seconds = numberTo2DigitsString(date.getSeconds());
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

function numberTo2DigitsString(number){
    return `${number<10?0:''}${number}`;
}
